/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Compare_DescriptionInputs */

const en_why_listening_compare_description = /** @type {(inputs: Why_Listening_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most read-aloud apps read everything on the page, cap how much you can listen and stay on one device. Listening doesn’t.`)
};

const es_why_listening_compare_description = /** @type {(inputs: Why_Listening_Compare_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La mayoría de las apps de lectura en voz alta leen todo lo que hay en la página, limitan cuánto puedes escuchar y funcionan en un solo dispositivo. Listening no.`)
};

/**
* | output |
* | --- |
* | "Most read-aloud apps read everything on the page, cap how much you can listen and stay on one device. Listening doesn’t." |
*
* @param {Why_Listening_Compare_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_compare_description = /** @type {((inputs?: Why_Listening_Compare_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Compare_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_compare_description(inputs)
	return en_why_listening_compare_description(inputs)
});